<template>
    <v-sheet
        class="w-100 pa-4 my-4"
        border
        rounded
        elevation="1"
        color="background"
    >
        <div
            class="d-flex flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row"
        >
            <!-- Content div -->
            <div class="flex-grow-1">
                <!-- Icono y título de estatus -->
                <div class="d-flex align-center">
                    <v-icon
                        v-if="elementos && elementos.length > 0"
                        :color="elementos[0].color"
                        :icon="elementos[0].icono"
                        size="small"
                        class="me-2"
                    ></v-icon>
                    <p
                        class="text-body-1 font-weight-bold text-uppercase"
                        :class="
                            elementos && elementos.length > 0
                                ? elementos[0].texto_color
                                : ''
                        "
                    >
                        {{ t("estatus-forma.etiqueta") }}:
                        {{ t("estatus-forma." + estatus + ".titulo") }}
                    </p>
                </div>
                <!-- Comentarios de revisión de operaciones -->
                <div
                    class="text-body-1 text-textDark text-justify mt-2 pl-6"
                    v-if="estatus == 4 && historial_revision"
                >
                    {{ historial_revision.comentarios }}
                    <!-- imágenes de historia revisión -->
                    <div
                        v-if="historial_revision.imagenes_revision.length > 0"
                        class="mt-4"
                    >
                        <listado-archivo
                            :listado="historial_revision.imagenes_revision"
                            :titulo="t('imagenes')"
                            tipo="imagen_revision"
                            :borrar="0"
                        >
                        </listado-archivo>
                    </div>
                </div>
                <!-- Texto fijo de estatus -->
                <div class="text-body-1 text-justify mt-2 pl-6" v-else>
                    <p class="text-textDark">
                        {{ t("estatus-forma." + estatus + ".texto") }}
                    </p>
                    <p
                        class="text-textLight text-body-2"
                        v-if="editable && stand == standId"
                    >
                        {{ t("estatus-forma." + estatus + ".nota") }}
                    </p>
                </div>
            </div>
            <!-- botón para regresar a modo de edición -->
            <div
                v-if="editable && stand == standId"
                class="d-flex align-center justify-center flex-shrink-0"
                :class="{
                    'mt-4': true,
                    'mt-sm-0': true,
                    'ms-sm-4': true,
                }"
            >
                <v-btn
                    :color="
                        elementos && elementos.length > 0
                            ? elementos[0].color
                            : 'primary'
                    "
                    variant="outlined"
                    @click="editar"
                >
                    {{ t("boton-editar") }}
                </v-btn>
            </div>
        </div>
    </v-sheet>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { router } from "@inertiajs/vue3";
import { computed } from "vue";

const { t } = useI18n();

const props = defineProps({
    item: Object, // objeto completo (decorador_stand, disenio_stand, maniobra)
    stand: Number, // identificador del stand
    id: Number, // identificador del registro de la forma (decorador_stand, disenio_stand, maniobras)
    tipo: Number, // 1: Decorador, 2: Disenio, 3: Paquete Premium
    estatus: Number,
    editable: Number,
    elementos: Array,
    historial_revision: Object,
});

// Computed properties para extraer valores de item si se proporciona
const standId = computed(() => {
    if (props.item) {
        // Intentar obtener stand_id de diferentes formas
        if (props.item.stand_id) return props.item.stand_id;
        if (props.item.stand?.id) return props.item.stand.id;
        if (props.item.stand_id) return props.item.stand_id;
    }
    return props.stand;
});

const itemId = computed(() => {
    if (props.item) {
        return props.item.id;
    }
    return props.id;
});

const itemTipo = computed(() => {
    if (props.item) {
        // Determinar tipo basado en las propiedades del item
        if (props.item.contratista !== undefined) return 1; // Decorador
        if (props.item.area !== undefined) return 2; // Diseño
    }
    return props.tipo;
});

// Función helper para obtener icono según estatus
const getIconoByEstatus = (estatus) => {
    const iconos = {
        0: "mdi-alert-circle",
        1: "mdi-clock-outline",
        2: "mdi-check-circle",
        3: "mdi-check-circle",
        4: "mdi-alert",
        5: "mdi-alert",
    };
    return iconos[estatus] || "mdi-information";
};

const estatus = computed(() => {
    if (props.item) {
        return props.item.estatus;
    }
    return props.estatus;
});

const elementos = computed(() => {
    if (props.elementos) {
        return props.elementos;
    }
    if (props.item) {
        // Si tiene estatus_elementos (maniobras)
        if (props.item.estatus_elementos) {
            return props.item.estatus_elementos;
        }
        // Si tiene estatus_info (decorador, disenio)
        if (props.item.estatus_info) {
            // Mapear estatus_info a formato elementos
            const estatusInfo = props.item.estatus_info;
            return [
                {
                    color: estatusInfo.color || "primary",
                    icono: getIconoByEstatus(estatus.value),
                    texto_color: `text-${estatusInfo.color || "primary"}`,
                },
            ];
        }
    }
    return [];
});

const editable = computed(() => {
    if (props.item) {
        return props.item.editable;
    }
    return props.editable;
});

const historial_revision = computed(() => {
    if (props.item) {
        return props.item.historial_revision;
    }
    return props.historial_revision;
});

const editar = () => {
    let routeName = "";
    let routeParams = { stand: standId.value };

    const tipo = itemTipo.value;
    const id = itemId.value;

    if (tipo == 1) {
        // Decorador
        routeName = "reglas.decorador-stands.estatus";
        routeParams.decorador_stand = id;
    } else if (tipo == 2) {
        // Diseño
        routeName = "reglas.disenio-stands.estatus";
        routeParams.disenio_stand = id;
    }

    if (routeName) {
        router.post(route(routeName, routeParams));
    }
};
</script>
